import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { styleClasses } from "../../helpers";
import "./Text.scss";
const CSS_PREFIX = `lav-components-text`;
export const Text = (_a) => {
    var { children, className = "", color = "black", onClick, size = "body2", underline } = _a, spanProps = __rest(_a, ["children", "className", "color", "onClick", "size", "underline"]);
    return (_jsx("span", { style: { display: "flex" }, children: _jsx("span", Object.assign({ className: classNames(styleClasses(CSS_PREFIX, { color, size, underline }), { [className]: !!className }), onClick: onClick }, spanProps, { children: children })) }));
};
